import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledMainContent = styled.div<{ banners?: boolean }>(
  ({ theme, banners }) => css`
    min-height: inherit;

    ${banners &&
    css`
      margin-block-start: calc(-1.125rem - 8 * (${theme.base.spacing}));
    `}
  `
);

StyledMainContent.defaultProps = defaultThemeProp;
